(function() { window.GUID_f4389f00_b456_4a06_abb0_4f1f856b259e = { getGuid: function() { return "f4389f00-b456-4a06-abb0-4f1f856b259e"; } }; })();
var CS;
(function (CS) {
    class User {
        User() {
        }
        static CheckIfAnythingToDo(jqXHR) {
            CS.UserHangfireTasks.CheckIfAnyTasks(jqXHR);
            CS.UserDisclaimer.CheckIfAnyDisclaimer(jqXHR);
        }
    }
    CS.User = User;
})(CS || (CS = {}));

//# sourceMappingURL=User.js.map
